<template>
  <div>
    <form class="login" @submit.prevent="resetPassword">
      <h1>Passwort ändern</h1>
      <div class="p-3 mb-2 bg-success text-white" v-if="isResetSuccess">
        Passwort erfolgreich geändert
      </div>
      <label>Neues Passwort</label>
      <input required v-model="password" type="password" />
      <label>Bestätige neues Passwort</label>
      <input required v-model="passwordConfirm" type="password" />
      <p>
        Passwort muss Folgendes enthalten: Großbuchstaben, Nummer,
        Sonderzeichen. Passwort muss mind. 6 Zeichen sein
      </p>
      <button type="submit">Speichern</button>
      <router-link class="mt-4" to="../login">zurück zur Anmeldung</router-link>
    </form>
  </div>
</template>

<style>
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
}
a {
  color: #2e426b;
  text-decoration: none;
}
</style>

<script>
import axios from "axios";
export default {
  name: "resetPassword",
  data() {
    return {
      password: "",
      passwordConfirm: "",
      token: "",
      username: "",
      isResetSuccess: false,
    };
  },

  created() {
    this.token = this.$route.query.token;
    this.username = this.$route.query.user;
  },

  methods: {
    resetPassword: function () {
      var encoded = encodeURIComponent(this.token)
      console.log("encoded => " + encoded);

      if (this.password === this.passwordConfirm) {
      this.changePasswordPost(encoded);
      }
    },

    changePasswordPost(encoded) {

      return axios.post( process.env.VUE_APP_API_PATH + "user/ResetPassword",
        { Username: this.username,
          Token: encoded,
          Password: this.password
        },
        { headers: {
        'Content-type': 'application/json',
        }
      }).then(() => {
          this.password = null;
          this.passwordConfirm = null;
          this.isResetSuccess = true;
      }).catch( res => { 
        console.log('error: ' + res.errors[0].description); 
        alert("Fehler, " + res.response.data.errors[0].description);
      });
    },
  },
};

</script>
